import { __read } from "tslib";
import { CustomFilterType, FileFilterKey, FileFilterToIconMap, LocationFilterKey, LocationFilterToIconMap, useFilterNameMap, } from '@office-start/base-edgeworth-control';
import { MenuItemTypes } from '@office-start/common-types';
import { isPcPlatform } from '@office-start/device-detection-utility';
import { DropdownMenu } from '@office-start/dropdown-menu';
import PillControl from '@office-start/pill-control';
import TagItemControl from '@office-start/tag-item-control';
import classNames from 'classnames';
import React, { lazy, Suspense, useCallback, useMemo, useState, } from 'react';
import styles from './CustomPivotsMenuControl.module.scss';
var LazyDropdownPeoplePicker = lazy(function () { return import('../DropdownPeoplePickerControl/DropdownPeoplePickerControl'); });
var customPivotMenuTitleId = 'customPivotMenuTitleId';
var customPivotMenuSubtitleId = 'customPivotMenuSubtitleId';
var ariaDescribedbyId = "".concat(customPivotMenuTitleId) + ' ' + "".concat(customPivotMenuSubtitleId);
// TODO: Add "Owned by me" as first item to Owned suggestions list
export var CustomPivotsMenuControl = function (_a) {
    var locResources = _a.locResources, getOrCreateUpnNameMap = _a.getOrCreateUpnNameMap, fetchPictureData = _a.fetchPictureData, _b = _a.fluidSupportEnabled, fluidSupportEnabled = _b === void 0 ? false : _b, linksEnabled = _a.linksEnabled, onSelectCustomFilter = _a.onSelectCustomFilter, tags = _a.tags;
    var _c = __read(useState(false), 2), fileTypePillSelected = _c[0], setFileTypePillSelected = _c[1];
    var _d = __read(useState(false), 2), fileLocationPillSelected = _d[0], setFileLocationPillSelected = _d[1];
    var _e = __read(useState(false), 2), fileTagsPillSelected = _e[0], setFileTagsPillSelected = _e[1];
    var filterNameMap = useFilterNameMap(locResources);
    var fileTypeDropdownMenuItems = useMemo(function () {
        return Object.values(FileFilterKey)
            .filter(function (key) {
            return (key !== FileFilterKey.fluid ||
                fluidSupportEnabled) &&
                (key !== FileFilterKey.link || linksEnabled) &&
                key !== FileFilterKey.designer;
        })
            .map(function (filterKey) {
            var _a;
            return {
                key: filterKey,
                content: (React.createElement("div", null,
                    React.createElement("div", { className: classNames(styles['dropdown-app-icon'], (_a = {},
                            _a[styles['fluid-icon']] = filterKey ===
                                'Fluid Filter',
                            _a)), "aria-hidden": "true" }, FileFilterToIconMap.get(filterKey)),
                    React.createElement("span", null, filterNameMap.get(filterKey)))),
            };
        })
            .filter(function (item) { return !!item; });
    }, [filterNameMap, fluidSupportEnabled, linksEnabled]);
    var onFileTypeDropdownItemSelected = useCallback(function (key, event) {
        if (onSelectCustomFilter) {
            event.preventDefault();
            event.stopPropagation();
            var customPivotFilter = {
                customFilterType: CustomFilterType.FileType,
                customFilterKey: key,
            };
            onSelectCustomFilter(customPivotFilter);
        }
    }, [onSelectCustomFilter]);
    var fileTypeDropdown = useMemo(function () { return (React.createElement(DropdownMenu, { buttonContent: React.createElement(PillControl, { title: locResources.typeFilterText, iconName: 'Document', isDropdown: true, isActive: fileTypePillSelected, disableFocus: true }), items: fileTypeDropdownMenuItems, options: {
            leftAligned: true,
            multiSelect: false,
        }, menuItemType: MenuItemTypes.List, onKeySelected: onFileTypeDropdownItemSelected, onDropdownOpened: function () { return setFileTypePillSelected(true); }, onDropdownClosed: function () { return setFileTypePillSelected(false); }, stopButtonEventPropagation: true, buttonAriaLabel: locResources.typeFilterText, ariaDescribedby: ariaDescribedbyId })); }, [
        locResources.typeFilterText,
        fileTypePillSelected,
        fileTypeDropdownMenuItems,
        onFileTypeDropdownItemSelected,
    ]);
    var fileLocationDropdownMenuItems = useMemo(function () {
        return Object.values(LocationFilterKey)
            .map(function (filterKey) {
            if (filterKey === LocationFilterKey.local &&
                !isPcPlatform()) {
                return undefined;
            }
            return {
                key: filterKey,
                content: (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: styles['custom-pivot-menu__dropdown-icon'] }, LocationFilterToIconMap.get(filterKey)),
                    React.createElement("span", null, filterNameMap.get(filterKey)))),
            };
        })
            .filter(function (item) { return !!item; });
    }, [filterNameMap]);
    var onFileLocationDropdownItemSelected = useCallback(function (key, event) {
        if (onSelectCustomFilter) {
            event.preventDefault();
            event.stopPropagation();
            var customPivotFilter = {
                customFilterType: CustomFilterType.Location,
                customFilterKey: key,
            };
            onSelectCustomFilter(customPivotFilter);
        }
    }, [onSelectCustomFilter]);
    var fileLocationDropdown = useMemo(function () {
        return (React.createElement(DropdownMenu, { buttonContent: React.createElement(PillControl, { title: locResources.locationFilterText, iconName: 'Folder', isDropdown: true, isActive: fileLocationPillSelected, disableFocus: true }), items: fileLocationDropdownMenuItems, options: {
                leftAligned: true,
                multiSelect: false,
            }, menuItemType: MenuItemTypes.List, onKeySelected: onFileLocationDropdownItemSelected, onDropdownOpened: function () { return setFileLocationPillSelected(true); }, onDropdownClosed: function () { return setFileLocationPillSelected(false); }, stopButtonEventPropagation: true, buttonAriaLabel: locResources.locationFilterText, ariaDescribedby: ariaDescribedbyId }));
    }, [
        locResources.locationFilterText,
        fileLocationPillSelected,
        fileLocationDropdownMenuItems,
        onFileLocationDropdownItemSelected,
    ]);
    var fileTagsDropdownMenuItems = useMemo(function () {
        if (!tags) {
            return [];
        }
        return Array.from(tags.tagIdToItemsDocumentIdsMap.values())
            .map(function (tuple) {
            var tag = tuple[0];
            return {
                key: tag.value,
                content: (React.createElement(TagItemControl, { tagItem: tag })),
            };
        })
            .filter(function (item) { return !!item; });
    }, [tags]);
    var onFileTagsDropdownItemSelected = useCallback(function (key, event) {
        var tagId;
        if (onSelectCustomFilter &&
            tags &&
            !!(tagId = tags.getTagIdByTagValue(key))) {
            event.preventDefault();
            event.stopPropagation();
            var customPivotFilter = {
                customFilterType: CustomFilterType.Tagv2,
                customFilterKey: tagId,
                customFilterTitle: key,
            };
            onSelectCustomFilter(customPivotFilter);
        }
    }, [onSelectCustomFilter, tags]);
    var onOwnedByDropdownItemSelected = useCallback(function (person) {
        if (onSelectCustomFilter) {
            var customPivotFilter = {
                customFilterType: CustomFilterType.OwnedBy,
                customFilterKey: person.key,
            };
            onSelectCustomFilter(customPivotFilter);
        }
    }, [onSelectCustomFilter]);
    var onSharedByDropdownItemSelected = useCallback(function (person) {
        if (onSelectCustomFilter) {
            var customPivotFilter = {
                customFilterType: CustomFilterType.SharedBy,
                customFilterKey: person.key,
            };
            onSelectCustomFilter(customPivotFilter);
        }
    }, [onSelectCustomFilter]);
    return locResources ? (React.createElement("div", { className: styles['custom-pivot-menu'] },
        React.createElement("div", { className: styles['custom-pivot-menu__title'], id: customPivotMenuTitleId }, locResources.customPivotMenuTitle),
        React.createElement("div", { className: styles['custom-pivot-menu__subtitle'], id: customPivotMenuSubtitleId }, locResources.customPivotMenuSubtitle),
        React.createElement("div", { className: styles['custom-pivot-menu__filters-container'] },
            fileTypeDropdown,
            fileLocationDropdown,
            React.createElement(Suspense, { fallback: null },
                React.createElement(LazyDropdownPeoplePicker, { dropdownTitle: locResources.sharedByText, locResources: locResources, maxSuggestions: 5, getOrCreateUpnNameMap: getOrCreateUpnNameMap, fetchPictureData: fetchPictureData, onPersonSelected: onSharedByDropdownItemSelected, key: "SharedBy", iconName: "People", ariaDescribedbyId: ariaDescribedbyId })),
            React.createElement(Suspense, { fallback: null },
                React.createElement(LazyDropdownPeoplePicker, { dropdownTitle: locResources.ownedByFilterText, locResources: locResources, maxSuggestions: 5, getOrCreateUpnNameMap: getOrCreateUpnNameMap, fetchPictureData: fetchPictureData, onPersonSelected: onOwnedByDropdownItemSelected, key: "OwnedBy", iconName: "Person", ariaDescribedbyId: ariaDescribedbyId })),
            tags ? (React.createElement(DropdownMenu, { buttonContent: React.createElement(PillControl, { title: "Tags", iconName: 'Tag', isDropdown: true, isActive: fileTagsPillSelected, disableFocus: true }), items: fileTagsDropdownMenuItems, options: {
                    leftAligned: true,
                    multiSelect: false,
                }, menuItemType: MenuItemTypes.List, onKeySelected: onFileTagsDropdownItemSelected, onDropdownOpened: function () {
                    return setFileTagsPillSelected(true);
                }, onDropdownClosed: function () {
                    return setFileTagsPillSelected(false);
                }, stopButtonEventPropagation: true, buttonAriaLabel: "Tag Dropdown Menu", ariaDescribedby: "Tag Dropdown Menu" })) : null))) : null;
};
//# sourceMappingURL=CustomPivotsMenuControl.js.map